import React, { useEffect, useState } from "react";
import GpsFanOutImage from "../../../assets/images/Defence/Products/GpsFanOutUnit.png";

// GPS FAN-OUT UNIT – SECTION COMPONENT (NO CONFLICT DESIGN)
const GpsFanOutUnit = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* GMAIL ENQUIRY HANDLER (PRODUCTION READY) */
  const handleMail = () => {
    const email = "sales@combatsolutions.ai";
    const subject = "Enquiry – RS-422 Fan-Out Unit";

    const body = `Hello Combat Solutions Team,

I am interested in receiving the technical specifications for the RS-422 Fan-Out Unit.

Product: RS-422 Fan-Out Unit

Company Name:
Designation:
Contact Number:
Deployment Platform (Naval / Airborne / Ground):

Additional Requirements / Questions:


Regards,
`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, "_blank");
  };

  //  GPS FAN-OUT UNIT – STYLE NAMESPACE (NO CONFLICT POSSIBLE)
  const gpsStyles = {
    gpsSection: {
      width: "100%",
      padding: isMobile ? "40px 24px" : "60px 60px",
      backgroundColor: "#ffffff",
    },

    gpsHeader: {
      textAlign: "center",
      marginBottom: isMobile ? "40px" : "60px",
    },

    gpsHeading: {
      fontSize: isMobile ? "26px" : "42px",
      fontWeight: 700,
      color: "#2b1a0f",
    },

    gpsSubheading: {
      marginTop: "10px",
      fontSize: isMobile ? "14px" : "16px",
      color: "#6b7280",
    },

    /*  MAIN FLEX CONTAINER */
    gpsContainer: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: isMobile ? "40px" : "70px",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: "1320px",
      margin: "0 auto",
    },

    /*  IMAGE COLUMN – PERFECT CENTERING FIX */
    gpsImageBox: {
      flex: isMobile ? "0 0 100%" : "0 0 48%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: isMobile ? "20px" : "0px",
    },

    gpsMainImage: {
      width: "100%",
      maxWidth: isMobile ? "300px" : "520px",
      objectFit: "contain",
    },

    /*  CONTENT COLUMN */
    gpsContentBox: {
      flex: isMobile ? "0 0 100%" : "0 0 48%",
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start",
      padding: isMobile ? "10px 0" : "20px 0",
    },

    gpsBadge: {
      display: "inline-block",
      backgroundColor: "#fff2e6",
      color: "#ff7a00",
      padding: "6px 14px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: 600,
      marginBottom: "20px",
      alignSelf: isMobile ? "center" : "flex-start",
    },

    gpsTitle: {
      fontSize: isMobile ? "24px" : "32px",
      fontWeight: 700,
      color: "#0f172a",
      marginBottom: "16px",
      textAlign: isMobile ? "center" : "left",
    },

    gpsDescription: {
      fontSize: isMobile ? "14px" : "15px",
      color: "#64748b",
      lineHeight: 1.7,
      marginBottom: "24px",
      maxWidth: "520px",
      textAlign: isMobile ? "center" : "left",
    },

    gpsFeatures: {
      listStyle: "none",
      padding: 0,
      marginBottom: "30px",
      width: "100%",
      maxWidth: isMobile ? "420px" : "520px",
    },

    gpsFeatureItem: {
      position: "relative",
      paddingLeft: "28px",
      marginBottom: "14px",
      fontSize: isMobile ? "13px" : "14px",
      color: "#1f2937",
    },

    gpsIcon: {
      position: "absolute",
      left: 0,
      top: 0,
      color: "#ff7a00",
      fontWeight: "bold",
    },

    gpsButton: {
      backgroundColor: "#ff7a00",
      color: "white",
      padding: isMobile ? "12px 22px" : "14px 26px",
      border: "none",
      borderRadius: "30px",
      fontSize: "14px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.3s ease",
      marginTop: "10px",
      alignSelf: isMobile ? "center" : "flex-start",
    },
  };

  return (
    <section style={gpsStyles.gpsSection}>
      {/* HEADER */}
      <div style={gpsStyles.gpsHeader}>
        <h1 style={gpsStyles.gpsHeading}>Indigenous Defence Products</h1>
        <p style={gpsStyles.gpsSubheading}>
          Designed, developed, and deployed for mission-critical systems
        </p>
      </div>

      {/* MAIN CONTENT */}
      <div style={gpsStyles.gpsContainer}>
        {/* LEFT IMAGE */}
        <div style={gpsStyles.gpsImageBox}>
          <img
            src={GpsFanOutImage}
            alt="GPS Fan Out Unit"
            style={gpsStyles.gpsMainImage}
          />
        </div>

        {/* RIGHT CONTENT */}
        <div style={gpsStyles.gpsContentBox}>
          <span style={gpsStyles.gpsBadge}>INDIGENOUS DESIGN</span>

          <h2 style={gpsStyles.gpsTitle}>RS-422 Fan-Out Unit</h2>

          <p style={gpsStyles.gpsDescription}>
            High-reliability signal distribution unit designed for weapon
            control systems and defence platforms. Features multiple isolated
            channels with EMI/EMC compliance for harsh combat environments.
          </p>

          <ul style={gpsStyles.gpsFeatures}>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              Multiple RS-422 differential output channels
            </li>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              Galvanic isolation between channels
            </li>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              MIL-STD-1553 compatible signal conditioning
            </li>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              Rugged aluminium chassis for harsh environments
            </li>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              Hot-swappable modules for field maintenance
            </li>
            <li style={gpsStyles.gpsFeatureItem}>
              <span style={gpsStyles.gpsIcon}>✔</span>
              Designed for naval and airborne platforms
            </li>
          </ul>

          {/*  GMAIL TRIGGER BUTTON */}
          <button style={gpsStyles.gpsButton} onClick={handleMail}>
            Request Technical Specifications
          </button>
        </div>
      </div>
    </section>
  );
};

export default GpsFanOutUnit;
